import React, { useRef } from "react";
import NavBar from "../../Components/NavBar";
import HomeBanner from "../../Components/Home/HomeBanner";
import Credentials from "../../Components/Credentials";
import FAQs from "../../Components/FAQs";
import HealthInsuranceHero from "../../Components/HealthInsuranceHero";
import OurProducts from "../../Components/OurProducts";

function HomePage() {
  const bannerRef = useRef(null);
  const scrollToRef = useRef(null);
  const credentialsRef = useRef(null);

  const scrollToContent = () => {
    if (scrollToRef.current) {
      scrollToRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="main-container">
      <NavBar />
      <section ref={bannerRef} className="panel">
        <HomeBanner scrollCallBack={scrollToContent} />
      </section>
      <OurProducts ref={scrollToRef} />

      <section ref={credentialsRef} className="panel">
        <Credentials />
        <FAQs bgWhite={false} />
        <HealthInsuranceHero />
      </section>
    </div>
  );
}

export default HomePage;
